import React from 'react';
import Comments from './Comments';
import { Context as CommentsContext } from './Context';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CommentsWithContext(_ref) {
  var contentId = _ref.contentId,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'asset' : _ref$contentType,
    readOnly = _ref.readOnly,
    _ref$canSubscribe = _ref.canSubscribe,
    canSubscribe = _ref$canSubscribe === void 0 ? true : _ref$canSubscribe,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'DEFAULT' : _ref$size,
    totalCount = _ref.totalCount;
  return /*#__PURE__*/_jsx(CommentsContext.Provider, {
    value: {
      contentId: contentId,
      contentType: contentType
    },
    children: contentId && /*#__PURE__*/_jsx(Comments, {
      readOnly: readOnly,
      size: size,
      canSubscribe: canSubscribe,
      totalCount: totalCount,
      contentId: contentId,
      contentType: contentType
    })
  });
}